import { useState } from "react";
import "./profile.css";

export default function ProfilePassword({ onSuccess }) {
  const [pwd, setPwd] = useState({
    current: "",
    next: "",
    confirm: "",
  });

  function handleChange(e) {
    setPwd({ ...pwd, [e.target.name]: e.target.value });
  }

  function submit() {
    if (!pwd.next || pwd.next !== pwd.confirm) {
      alert("Les mots de passe ne correspondent pas");
      return;
    }

    
    setTimeout(() => {
      setPwd({ current: "", next: "", confirm: "" });
      onSuccess();
    }, 800);
  }

  return (
    <div className="profileBox">
      <h3>Sécurité</h3>

      <div className="formGroup">
        <label>Mot de passe actuel</label>
        <input
          type="password"
          name="current"
          value={pwd.current}
          onChange={handleChange}
        />
      </div>

      <div className="formGroup">
        <label>Nouveau mot de passe</label>
        <input
          type="password"
          name="next"
          value={pwd.next}
          onChange={handleChange}
        />
      </div>

      <div className="formGroup">
        <label>Confirmer</label>
        <input
          type="password"
          name="confirm"
          value={pwd.confirm}
          onChange={handleChange}
        />
      </div>

      <button className="btnDanger" onClick={submit}>
        Mettre à jour le mot de passe
      </button>
    </div>
  );
}
